export default "__VITE_ASSET__PrPeLTl9__"